<template>
  <li class="px-4 py-2 hover:bg-zinc-400/10 hover:dark:bg-zinc-50/5 cursor-pointer">
    <RouterLink class="block w-full text-lg py-1" :to="{ name: 'organization', params: { id: organization.id } }">{{ organization.name }}</RouterLink>
  </li>
</template>

<script setup>
import { RouterLink } from "vue-router";

defineProps({
  organization: {
    type: Object,
    default: () => { }
  }
})
</script>
